module.exports = __webpack_public_path__ + "img/3ds_code_ok.fa4bd785.png";